import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

function Title({ query, paging: { total } }: any) {
  if (!total || !query) {
    return null;
  }

  return (
    <Typography component="h1" variant="h4" align="center">
      <FormattedMessage id="SEARCH.RESULTS_COUNT" values={{ count: total }} />
    </Typography>
  );
}

export default Title;
